import { createAppWrap } from '../../create_app_wrap';
import flashMessageMixin from '../../mixins/_flash_messages';
import templateList from './_template_list_component';


const view = '[data-view="canva_templates-index"]';
const init = () => {
    createAppWrap({
        el: view,
        components: {
            'template-list': templateList,
        },
        mixins: [flashMessageMixin],
    });
};

if (document.querySelector(view)) {
    init();
}
